class SaleNotifications extends HTMLElement {
  connectedCallback() {
    const cfg = this._parseConfig();
    if (!cfg || !cfg.products.length || !cfg.names.length) return;

    this._cfg = cfg;
    this._intervalMs = parseInt(this.dataset.interval, 10) * 1000;
    this._durationMs = parseInt(this.dataset.duration, 10) * 1000;

    this._notif      = this.querySelector('.sale-notif');
    this._thumbLink  = this.querySelector('.sale-notif__thumb');
    this._img        = this.querySelector('.sale-notif__img');
    this._nameEl     = this.querySelector('.sale-notif__name');
    this._actionEl   = this.querySelector('.sale-notif__action');
    this._productEl  = this.querySelector('.sale-notif__product');
    this._timeEl     = this.querySelector('.sale-notif__time');
    this._locationEl = this.querySelector('.sale-notif__location');
    this._closeBtn   = this.querySelector('.sale-notif__close');

    this._closeBtn?.addEventListener('click', () => this._hide(true));

    this._timer = null;
    this._hideTimer = null;

    // First show after 2s
    this._timer = setTimeout(() => this._show(), 2000);
  }

  disconnectedCallback() {
    clearTimeout(this._timer);
    clearTimeout(this._hideTimer);
  }

  _parseConfig() {
    try {
      const el = this.querySelector('script[type="application/json"]');
      if (!el) return null;
      const data = JSON.parse(el.textContent);
      // Trim whitespace from split arrays
      data.names     = data.names.map(s => s.trim()).filter(Boolean);
      data.locations = data.locations.map(s => s.trim()).filter(Boolean);
      data.times     = data.times.map(s => s.trim()).filter(Boolean);
      return data;
    } catch (e) {
      return null;
    }
  }

  _pick(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
  }

  _show() {
    const { names, products, locations, times, actionText } = this._cfg;
    const name     = this._pick(names);
    const product  = this._pick(products);
    const time     = this._pick(times);
    const location = this._pick(locations);

    if (this._nameEl)     this._nameEl.textContent    = name;
    if (this._actionEl)   this._actionEl.textContent  = ' ' + actionText;
    if (this._timeEl)     this._timeEl.textContent     = time;
    if (this._locationEl) this._locationEl.textContent = location;

    if (this._productEl) {
      this._productEl.textContent = product.title;
      this._productEl.href        = product.url;
    }

    if (product.image) {
      if (this._img) {
        this._img.src = product.image;
        this._img.alt = product.title;
      }
      if (this._thumbLink) this._thumbLink.href = product.url;
      this._thumbLink?.removeAttribute('hidden');
    } else {
      this._thumbLink?.setAttribute('hidden', '');
    }

    // Slide in
    this._notif?.classList.add('sale-notif--visible');

    // Auto-hide after duration
    this._hideTimer = setTimeout(() => this._hide(false), this._durationMs);
  }

  _hide(immediate) {
    clearTimeout(this._hideTimer);

    // Slide out — override to ease-in (no bounce on exit)
    if (this._notif) {
      this._notif.style.transition =
        'transform 0.35s ease-in, opacity 0.3s ease-in';
      this._notif.classList.remove('sale-notif--visible');

      // Restore original transition after exit completes
      setTimeout(() => {
        if (this._notif) this._notif.style.transition = '';
      }, 380);
    }

    if (!immediate) {
      this._timer = setTimeout(() => this._show(), this._intervalMs);
    }
  }
}

customElements.define('sale-notifications', SaleNotifications);
